import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import React from "react";
import { createRoot } from "react-dom/client";
import { loginRedirectRequest, msalConfig } from "src/authConfig";
import { InitializationPage } from "./InitializationPage";
import "./index.css";

export const msalInstance = new PublicClientApplication(msalConfig);

(async () => {
  await msalInstance.initialize();

  const response = await msalInstance.handleRedirectPromise();

  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  if (!msalInstance.getActiveAccount()) {
    await msalInstance.loginRedirect(loginRedirectRequest);
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      msalInstance.setActiveAccount(payload.account);
    }
  });

  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <InitializationPage pca={msalInstance} />
    </React.StrictMode>
  );
})();
